import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TransferEnviromentService } from './transferEnviroment.service';
import { IEnviroment } from '../interfaces/ienviroment';

import { Institution } from '../models/institution.model';
import { EducationService } from '../models/educationService.model';
import { Building } from '../models/building.model';
import { Department } from '../models/department.model';
import { Innovation } from '../models/innovation.model';
import { EducationContract } from '../models/educationContract.model';
import { PublicDigitalService } from '../models/publicDigitalService.model';
import { Territory } from '../models/territory.model';
import { BaseService } from '@n3/ng-api-base-kit';

/**
 * @name IInstitutionGet
 *
 * @param *id - Идентификатор организации 
 */
export interface IInstitutionGet {
    id: string;
}

/**
 * @name IEducationServiceGet
 *
 * @param *id - Идентификатор образовательной услуги 
 */
export interface IEducationServiceGet {
    id: string;
}

/**
 * @name IBuildingGet
 *
 * @param *id - Идентификатор здания 
 */
export interface IBuildingGet {
    id: string;
}

/**
 * @name IDepartmentGet
 *
 * @param *id - Идентификатор подразделения 
 */
export interface IDepartmentGet {
    id: string;
}

/**
 * @name IInnovationGet
 *
 * @param *id - Идентификатор инновации 
 */
export interface IInnovationGet {
    id: string;
}

/**
 * @name IEducationContractGet
 *
 * @param *id - Идентификатор договора 
 */
export interface IEducationContractGet {
    id: string;
}

/**
 * @name IPublicDigitalServiceGet
 *
 * @param *id - Идентификатор услуги 
 */
export interface IPublicDigitalServiceGet {
    id: string;
}

/**
 * @name ITerritoryGet
 *
 * @param *id - Идентификатор территории 
 */
export interface ITerritoryGet {
    id: string;
}

/**
 * @name IInstitutionSoftDelete
 *
 * @param *id - Идентификатор организации 
 */
export interface IInstitutionSoftDelete {
    id: string;
}

/**
 * @name IInstitutionDelete
 *
 * @param *id - Идентификатор организации 
 */
export interface IInstitutionDelete {
    id: string;
}

/**
 * @name IInstitutionRestore
 *
 * @param *id - Идентификатор организации 
 */
export interface IInstitutionRestore {
    id: string;
}

/**
 * @name IEducationServiceSoftDelete
 *
 * @param *id - Идентификатор образовательной услуги 
 */
export interface IEducationServiceSoftDelete {
    id: string;
}

/**
 * @name IEducationServiceDelete
 *
 * @param *id - Идентификатор образовательной услуги 
 */
export interface IEducationServiceDelete {
    id: string;
}

/**
 * @name IEducationServiceRestore
 *
 * @param *id - Идентификатор образовательной услуги 
 */
export interface IEducationServiceRestore {
    id: string;
}

/**
 * @name IBuildingSoftDelete
 *
 * @param *id - Идентификатор здания 
 */
export interface IBuildingSoftDelete {
    id: string;
}

/**
 * @name IBuildingDelete
 *
 * @param *id - Идентификатор здания 
 */
export interface IBuildingDelete {
    id: string;
}

/**
 * @name IBuildingRestore
 *
 * @param *id - Идентификатор здания 
 */
export interface IBuildingRestore {
    id: string;
}

/**
 * @name IDepartmentSoftDelete
 *
 * @param *id - Идентификатор подразделения 
 */
export interface IDepartmentSoftDelete {
    id: string;
}

/**
 * @name IDepartmentDelete
 *
 * @param *id - Идентификатор подразделения 
 */
export interface IDepartmentDelete {
    id: string;
}

/**
 * @name IDepartmentRestore
 *
 * @param *id - Идентификатор подразделения 
 */
export interface IDepartmentRestore {
    id: string;
}

/**
 * @name IInnovationSoftDelete
 *
 * @param *id - Идентификатор инновации 
 */
export interface IInnovationSoftDelete {
    id: string;
}

/**
 * @name IInnovationDelete
 *
 * @param *id - Идентификатор инновации 
 */
export interface IInnovationDelete {
    id: string;
}

/**
 * @name IInnovationRestore
 *
 * @param *id - Идентификатор инновации 
 */
export interface IInnovationRestore {
    id: string;
}

/**
 * @name IEducationContractSoftDelete
 *
 * @param *id - Идентификатор договора на осуществление образовательной деятельности 
 */
export interface IEducationContractSoftDelete {
    id: string;
}

/**
 * @name IEducationContractDelete
 *
 * @param *id - Идентификатор договора на осуществление образовательной деятельности 
 */
export interface IEducationContractDelete {
    id: string;
}

/**
 * @name IEducationContractRestore
 *
 * @param *id - Идентификатор договора на осуществление образовательной деятельности 
 */
export interface IEducationContractRestore {
    id: string;
}

/**
 * @name IPublicDigitalServiceSoftDelete
 *
 * @param *id - Идентификатор услуги в электронном виде 
 */
export interface IPublicDigitalServiceSoftDelete {
    id: string;
}

/**
 * @name IPublicDigitalServiceDelete
 *
 * @param *id - Идентификатор услуги в электронном виде 
 */
export interface IPublicDigitalServiceDelete {
    id: string;
}

/**
 * @name IPublicDigitalServiceRestore
 *
 * @param *id - Идентификатор услуги в электронном виде 
 */
export interface IPublicDigitalServiceRestore {
    id: string;
}

/**
 * @name ITerritorySoftDelete
 *
 * @param *id - Идентификатор территории 
 */
export interface ITerritorySoftDelete {
    id: string;
}

/**
 * @name ITerritoryDelete
 *
 * @param *id - Идентификатор территории 
 */
export interface ITerritoryDelete {
    id: string;
}

/**
 * @name ITerritoryRestore
 *
 * @param *id - Идентификатор территории 
 */
export interface ITerritoryRestore {
    id: string;
}

/**
 * @name IOrganizationList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_regions - Регионы 
 * @param p_districts - Районы 
 * @param p_okopfs - ОКОПФ 
 * @param p_okfses - ОКФС 
 * @param p_organization_statuses - Статусы организаций 
 * @param p_deleted - Показывать удаленные 
 */
export interface IOrganizationList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_regions?: number[];
    p_districts?: number[];
    p_okopfs?: number[];
    p_okfses?: number[];
    p_organization_statuses?: number[];
    p_deleted?: boolean;
}

/**
 * @name IInstitutionList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_regions - Регионы 
 * @param p_districts - Районы 
 * @param p_institution_types - Типы ОО 
 * @param p_institution_kinds - Вид образования 
 * @param p_education_levels - Уровени образования 
 * @param p_okopfs - ОКОПФ 
 * @param p_okfses - ОКФС 
 * @param p_institution_statuses - Статус образовательной организации 
 * @param p_jurisdictions - Подведомственность 
 * @param p_education_orientations - Направленности 
 * @param p_deleted - Показывать удаленные 
 */
export interface IInstitutionList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_regions?: number[];
    p_districts?: number[];
    p_institution_types?: number[];
    p_institution_kinds?: number[];
    p_education_levels?: number[];
    p_okopfs?: number[];
    p_okfses?: number[];
    p_institution_statuses?: number[];
    p_jurisdictions?: number[];
    p_education_orientations?: number[];
    p_deleted?: boolean;
}

/**
 * @name IEducationServiceList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_institutions - Образовательные организации 
 * @param p_deleted - Показывать удаленные 
 */
export interface IEducationServiceList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_institutions?: number[];
    p_deleted?: boolean;
}

/**
 * @name IBuildingList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_institutions - Образовательные организации 
 * @param p_deleted - Показывать удаленные 
 */
export interface IBuildingList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_institutions?: number[];
    p_deleted?: boolean;
}

/**
 * @name IDepartmentList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_institutions - Образовательные организации 
 * @param p_deleted - Показывать удаленные 
 */
export interface IDepartmentList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_institutions?: number[];
    p_deleted?: boolean;
}

/**
 * @name IInnovationList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_institutions - Образовательные организации 
 * @param p_deleted - Показывать удаленные 
 */
export interface IInnovationList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_institutions?: number[];
    p_deleted?: boolean;
}

/**
 * @name IEducationContractList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_institutions - Образовательные организации 
 * @param p_deleted - Показывать удаленные 
 */
export interface IEducationContractList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_institutions?: number[];
    p_deleted?: boolean;
}

/**
 * @name IPublicDigitalServiceList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_institutions - Образовательные организации 
 * @param p_deleted - Показывать удаленные 
 */
export interface IPublicDigitalServiceList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_institutions?: number[];
    p_deleted?: boolean;
}

/**
 * @name ITerritoryList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_institutions - Образовательные организации 
 * @param p_deleted - Показывать удаленные 
 */
export interface ITerritoryList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_institutions?: number[];
    p_deleted?: boolean;
}

/**
 * @name IInstitutionMap
 *
 * @param p_search - Поисковая строка 
 * @param p_regions - Регионы 
 * @param p_districts - Районы 
 * @param p_institution_types - Типы ОО 
 * @param p_institution_kinds - Вид образования 
 * @param p_education_levels - Уровени образования 
 * @param p_okopfs - ОКОПФ 
 * @param p_okfses - ОКФС 
 * @param p_institution_statuses - Статус образовательной организации 
 * @param p_jurisdictions - Подведомственность 
 * @param p_education_orientations - Направленности 
 * @param p_deleted - Показывать удаленные 
 */
export interface IInstitutionMap {
    p_search?: string;
    p_regions?: number[];
    p_districts?: number[];
    p_institution_types?: number[];
    p_institution_kinds?: number[];
    p_education_levels?: number[];
    p_okopfs?: number[];
    p_okfses?: number[];
    p_institution_statuses?: number[];
    p_jurisdictions?: number[];
    p_education_orientations?: number[];
    p_deleted?: boolean;
}

/**
 * @name IInstitutionExport
 *
 * @param *format - Формат выгрузки [XLS,XLSX,PDF,DOC,DOCX,RTF,CSV]
 * @param p_search - Поисковая строка 
 * @param p_regions - Регионы 
 * @param p_districts - Районы 
 * @param p_institution_types - Типы ОО 
 * @param p_institution_kinds - Вид образования 
 * @param p_education_levels - Уровени образования 
 * @param p_okopfs - ОКОПФ 
 * @param p_okfses - ОКФС 
 * @param p_institution_statuses - Статус образовательной организации 
 * @param p_jurisdictions - Подведомственность 
 * @param p_education_orientations - Направленности 
 * @param p_deleted - Показывать удаленные 
 */
export interface IInstitutionExport {
    format: string[];
    p_search?: string;
    p_regions?: number[];
    p_districts?: number[];
    p_institution_types?: number[];
    p_institution_kinds?: number[];
    p_education_levels?: number[];
    p_okopfs?: number[];
    p_okfses?: number[];
    p_institution_statuses?: number[];
    p_jurisdictions?: number[];
    p_education_orientations?: number[];
    p_deleted?: boolean;
}

/**
 * @name IInstitutionGetOrganization
 *
 * @param *id - Идентификатор образовательной организации 
 */
export interface IInstitutionGetOrganization {
    id: string;
}

/**
 * @name IInstitutionDuplicateInn
 *
 * @param *inn - ИНН юр. лица 
 */
export interface IInstitutionDuplicateInn {
    inn: string;
}

/**
 * @name IInstitutionDuplicateOgrn
 *
 * @param *ogrn - ОГРН юр. лица 
 */
export interface IInstitutionDuplicateOgrn {
    ogrn: string;
}

/**
 * @name IInstitutionSave
 *
 * @param *body -   
 */
export interface IInstitutionSave {
    body: Institution;
}

/**
 * @name IEducationServiceSave
 *
 * @param *body -   
 */
export interface IEducationServiceSave {
    body: EducationService;
}

/**
 * @name IBuildingSave
 *
 * @param *body -   
 */
export interface IBuildingSave {
    body: Building;
}

/**
 * @name IDepartmentSave
 *
 * @param *body -   
 */
export interface IDepartmentSave {
    body: Department;
}

/**
 * @name IInnovationSave
 *
 * @param *body -   
 */
export interface IInnovationSave {
    body: Innovation;
}

/**
 * @name IEducationContractSave
 *
 * @param *body -   
 */
export interface IEducationContractSave {
    body: EducationContract;
}

/**
 * @name IPublicDigitalServiceSave
 *
 * @param *body -   
 */
export interface IPublicDigitalServiceSave {
    body: PublicDigitalService;
}

/**
 * @name ITerritorySave
 *
 * @param *body -   
 */
export interface ITerritorySave {
    body: Territory;
}



@Injectable()
export class InstitutionService {
    private enviroment: IEnviroment;
    constructor(private base: BaseService, private enviromentService: TransferEnviromentService) { 
        this.enviroment = enviromentService.getEnviroment();
    }

    /**
     * Получает образовательную организацию и связанное юр. лицо по ее id
     * @method
     * @name institutionGet
     * @param data - объект с данными типа IInstitutionGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionGet(
        data: IInstitutionGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает образовательную услугу для УФТТ 3.0 ее id
     * @method
     * @name educationServiceGet
     * @param data - объект с данными типа IEducationServiceGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationServiceGet(
        data: IEducationServiceGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-service/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает здание по его id
     * @method
     * @name buildingGet
     * @param data - объект с данными типа IBuildingGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public buildingGet(
        data: IBuildingGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/building/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает подразделение по его id
     * @method
     * @name departmentGet
     * @param data - объект с данными типа IDepartmentGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public departmentGet(
        data: IDepartmentGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/department/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает инновацию по его id
     * @method
     * @name innovationGet
     * @param data - объект с данными типа IInnovationGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public innovationGet(
        data: IInnovationGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/innovation/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает договор на осуществление образовательной деятельности по его id
     * @method
     * @name educationContractGet
     * @param data - объект с данными типа IEducationContractGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationContractGet(
        data: IEducationContractGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-contract/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает услуги в электронном виде по id
     * @method
     * @name publicDigitalServiceGet
     * @param data - объект с данными типа IPublicDigitalServiceGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public publicDigitalServiceGet(
        data: IPublicDigitalServiceGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/public-digital-service/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает территорию по id
     * @method
     * @name territoryGet
     * @param data - объект с данными типа ITerritoryGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public territoryGet(
        data: ITerritoryGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/territory/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет образовательные организации и связанное юр. лицо по id
     * @method
     * @name institutionSoftDelete
     * @param data - объект с данными типа IInstitutionSoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionSoftDelete(
        data: IInstitutionSoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет образовательные организации и связанное юр. лицо по id
     * @method
     * @name institutionDelete
     * @param data - объект с данными типа IInstitutionDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionDelete(
        data: IInstitutionDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает образовательные организации и связанное юр. лицо по id
     * @method
     * @name institutionRestore
     * @param data - объект с данными типа IInstitutionRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionRestore(
        data: IInstitutionRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет образовательные услуги для УФТТ 3.0 по id
     * @method
     * @name educationServiceSoftDelete
     * @param data - объект с данными типа IEducationServiceSoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationServiceSoftDelete(
        data: IEducationServiceSoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-service/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет образовательные услуги для УФТТ 3.0 по id
     * @method
     * @name educationServiceDelete
     * @param data - объект с данными типа IEducationServiceDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationServiceDelete(
        data: IEducationServiceDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-service/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает образовательные услуги для УФТТ 3.0 по id
     * @method
     * @name educationServiceRestore
     * @param data - объект с данными типа IEducationServiceRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationServiceRestore(
        data: IEducationServiceRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-service/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет здания по id
     * @method
     * @name buildingSoftDelete
     * @param data - объект с данными типа IBuildingSoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public buildingSoftDelete(
        data: IBuildingSoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/building/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет здания по id
     * @method
     * @name buildingDelete
     * @param data - объект с данными типа IBuildingDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public buildingDelete(
        data: IBuildingDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/building/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает здания по id
     * @method
     * @name buildingRestore
     * @param data - объект с данными типа IBuildingRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public buildingRestore(
        data: IBuildingRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/building/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет подразделения по id
     * @method
     * @name departmentSoftDelete
     * @param data - объект с данными типа IDepartmentSoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public departmentSoftDelete(
        data: IDepartmentSoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/department/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет подразделения по id
     * @method
     * @name departmentDelete
     * @param data - объект с данными типа IDepartmentDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public departmentDelete(
        data: IDepartmentDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/department/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает подразделения по id
     * @method
     * @name departmentRestore
     * @param data - объект с данными типа IDepartmentRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public departmentRestore(
        data: IDepartmentRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/department/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет инновации по id
     * @method
     * @name innovationSoftDelete
     * @param data - объект с данными типа IInnovationSoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public innovationSoftDelete(
        data: IInnovationSoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/innovation/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет инновации по id
     * @method
     * @name innovationDelete
     * @param data - объект с данными типа IInnovationDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public innovationDelete(
        data: IInnovationDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/innovation/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает инновации по id
     * @method
     * @name innovationRestore
     * @param data - объект с данными типа IInnovationRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public innovationRestore(
        data: IInnovationRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/innovation/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет договора на осуществление образовательной деятельности по id
     * @method
     * @name educationContractSoftDelete
     * @param data - объект с данными типа IEducationContractSoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationContractSoftDelete(
        data: IEducationContractSoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-contract/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет договора на осуществление образовательной деятельности по id
     * @method
     * @name educationContractDelete
     * @param data - объект с данными типа IEducationContractDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationContractDelete(
        data: IEducationContractDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-contract/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает договора на осуществление образовательной деятельности по id
     * @method
     * @name educationContractRestore
     * @param data - объект с данными типа IEducationContractRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationContractRestore(
        data: IEducationContractRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-contract/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет услуги в электронном виде по id
     * @method
     * @name publicDigitalServiceSoftDelete
     * @param data - объект с данными типа IPublicDigitalServiceSoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public publicDigitalServiceSoftDelete(
        data: IPublicDigitalServiceSoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/public-digital-service/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет услуги в электронном виде по id
     * @method
     * @name publicDigitalServiceDelete
     * @param data - объект с данными типа IPublicDigitalServiceDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public publicDigitalServiceDelete(
        data: IPublicDigitalServiceDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/public-digital-service/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает услуги в электронном виде по id
     * @method
     * @name publicDigitalServiceRestore
     * @param data - объект с данными типа IPublicDigitalServiceRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public publicDigitalServiceRestore(
        data: IPublicDigitalServiceRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/public-digital-service/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Логически удаляет территорию по id
     * @method
     * @name territorySoftDelete
     * @param data - объект с данными типа ITerritorySoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public territorySoftDelete(
        data: ITerritorySoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/territory/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Удаляет территорию по id
     * @method
     * @name territoryDelete
     * @param data - объект с данными типа ITerritoryDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public territoryDelete(
        data: ITerritoryDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/territory/delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает территорию по id
     * @method
     * @name territoryRestore
     * @param data - объект с данными типа ITerritoryRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public territoryRestore(
        data: ITerritoryRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/territory/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Получает список юр. лиц в постраничном разбиении
     * @method
     * @name organizationList
     * @param data - объект с данными типа IOrganizationList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public organizationList(
        data: IOrganizationList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/organization/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null ) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map((item) => {
                    search.push({param: 'p_regions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_regions', value: '' + data.p_regions});
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null ) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map((item) => {
                    search.push({param: 'p_districts[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_districts', value: '' + data.p_districts});
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null ) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map((item) => {
                    search.push({param: 'p_okopfs[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okopfs', value: '' + data.p_okopfs});
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null ) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map((item) => {
                    search.push({param: 'p_okfses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okfses', value: '' + data.p_okfses});
            }
        }
        if (typeof data.p_organization_statuses !== 'undefined' && data.p_organization_statuses !== null ) {
            if (Array.isArray(data.p_organization_statuses)) {
                data.p_organization_statuses.map((item) => {
                    search.push({param: 'p_organization_statuses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_organization_statuses', value: '' + data.p_organization_statuses});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список образовательных организаций в постраничном разбиении
     * @method
     * @name institutionList
     * @param data - объект с данными типа IInstitutionList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionList(
        data: IInstitutionList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null ) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map((item) => {
                    search.push({param: 'p_regions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_regions', value: '' + data.p_regions});
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null ) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map((item) => {
                    search.push({param: 'p_districts[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_districts', value: '' + data.p_districts});
            }
        }
        if (typeof data.p_institution_types !== 'undefined' && data.p_institution_types !== null ) {
            if (Array.isArray(data.p_institution_types)) {
                data.p_institution_types.map((item) => {
                    search.push({param: 'p_institution_types[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_types', value: '' + data.p_institution_types});
            }
        }
        if (typeof data.p_institution_kinds !== 'undefined' && data.p_institution_kinds !== null ) {
            if (Array.isArray(data.p_institution_kinds)) {
                data.p_institution_kinds.map((item) => {
                    search.push({param: 'p_institution_kinds[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_kinds', value: '' + data.p_institution_kinds});
            }
        }
        if (typeof data.p_education_levels !== 'undefined' && data.p_education_levels !== null ) {
            if (Array.isArray(data.p_education_levels)) {
                data.p_education_levels.map((item) => {
                    search.push({param: 'p_education_levels[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_education_levels', value: '' + data.p_education_levels});
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null ) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map((item) => {
                    search.push({param: 'p_okopfs[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okopfs', value: '' + data.p_okopfs});
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null ) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map((item) => {
                    search.push({param: 'p_okfses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okfses', value: '' + data.p_okfses});
            }
        }
        if (typeof data.p_institution_statuses !== 'undefined' && data.p_institution_statuses !== null ) {
            if (Array.isArray(data.p_institution_statuses)) {
                data.p_institution_statuses.map((item) => {
                    search.push({param: 'p_institution_statuses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_statuses', value: '' + data.p_institution_statuses});
            }
        }
        if (typeof data.p_jurisdictions !== 'undefined' && data.p_jurisdictions !== null ) {
            if (Array.isArray(data.p_jurisdictions)) {
                data.p_jurisdictions.map((item) => {
                    search.push({param: 'p_jurisdictions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_jurisdictions', value: '' + data.p_jurisdictions});
            }
        }
        if (typeof data.p_education_orientations !== 'undefined' && data.p_education_orientations !== null ) {
            if (Array.isArray(data.p_education_orientations)) {
                data.p_education_orientations.map((item) => {
                    search.push({param: 'p_education_orientations[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_education_orientations', value: '' + data.p_education_orientations});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список образовательных услуг для УФТТ 3.0 в постраничном разбиении
     * @method
     * @name educationServiceList
     * @param data - объект с данными типа IEducationServiceList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationServiceList(
        data: IEducationServiceList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-service/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null ) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map((item) => {
                    search.push({param: 'p_institutions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institutions', value: '' + data.p_institutions});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список зданий в постраничном разбиении
     * @method
     * @name buildingList
     * @param data - объект с данными типа IBuildingList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public buildingList(
        data: IBuildingList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/building/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null ) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map((item) => {
                    search.push({param: 'p_institutions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institutions', value: '' + data.p_institutions});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список подразделений в постраничном разбиении
     * @method
     * @name departmentList
     * @param data - объект с данными типа IDepartmentList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public departmentList(
        data: IDepartmentList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/department/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null ) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map((item) => {
                    search.push({param: 'p_institutions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institutions', value: '' + data.p_institutions});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список инноваций в постраничном разбиении
     * @method
     * @name innovationList
     * @param data - объект с данными типа IInnovationList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public innovationList(
        data: IInnovationList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/innovation/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null ) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map((item) => {
                    search.push({param: 'p_institutions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institutions', value: '' + data.p_institutions});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список договоров на осуществление образовательной деятельности в постраничном разбиении
     * @method
     * @name educationContractList
     * @param data - объект с данными типа IEducationContractList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationContractList(
        data: IEducationContractList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-contract/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null ) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map((item) => {
                    search.push({param: 'p_institutions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institutions', value: '' + data.p_institutions});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список услуг в электронном виде в постраничном разбиении
     * @method
     * @name publicDigitalServiceList
     * @param data - объект с данными типа IPublicDigitalServiceList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public publicDigitalServiceList(
        data: IPublicDigitalServiceList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/public-digital-service/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null ) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map((item) => {
                    search.push({param: 'p_institutions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institutions', value: '' + data.p_institutions});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список территорий в постраничном разбиении
     * @method
     * @name territoryList
     * @param data - объект с данными типа ITerritoryList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public territoryList(
        data: ITerritoryList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/territory/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_institutions !== 'undefined' && data.p_institutions !== null ) {
            if (Array.isArray(data.p_institutions)) {
                data.p_institutions.map((item) => {
                    search.push({param: 'p_institutions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institutions', value: '' + data.p_institutions});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает список образовательных организаций для вывода на карте
     * @method
     * @name institutionMap
     * @param data - объект с данными типа IInstitutionMap
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionMap(
        data: IInstitutionMap,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/map';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null ) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map((item) => {
                    search.push({param: 'p_regions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_regions', value: '' + data.p_regions});
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null ) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map((item) => {
                    search.push({param: 'p_districts[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_districts', value: '' + data.p_districts});
            }
        }
        if (typeof data.p_institution_types !== 'undefined' && data.p_institution_types !== null ) {
            if (Array.isArray(data.p_institution_types)) {
                data.p_institution_types.map((item) => {
                    search.push({param: 'p_institution_types[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_types', value: '' + data.p_institution_types});
            }
        }
        if (typeof data.p_institution_kinds !== 'undefined' && data.p_institution_kinds !== null ) {
            if (Array.isArray(data.p_institution_kinds)) {
                data.p_institution_kinds.map((item) => {
                    search.push({param: 'p_institution_kinds[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_kinds', value: '' + data.p_institution_kinds});
            }
        }
        if (typeof data.p_education_levels !== 'undefined' && data.p_education_levels !== null ) {
            if (Array.isArray(data.p_education_levels)) {
                data.p_education_levels.map((item) => {
                    search.push({param: 'p_education_levels[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_education_levels', value: '' + data.p_education_levels});
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null ) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map((item) => {
                    search.push({param: 'p_okopfs[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okopfs', value: '' + data.p_okopfs});
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null ) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map((item) => {
                    search.push({param: 'p_okfses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okfses', value: '' + data.p_okfses});
            }
        }
        if (typeof data.p_institution_statuses !== 'undefined' && data.p_institution_statuses !== null ) {
            if (Array.isArray(data.p_institution_statuses)) {
                data.p_institution_statuses.map((item) => {
                    search.push({param: 'p_institution_statuses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_statuses', value: '' + data.p_institution_statuses});
            }
        }
        if (typeof data.p_jurisdictions !== 'undefined' && data.p_jurisdictions !== null ) {
            if (Array.isArray(data.p_jurisdictions)) {
                data.p_jurisdictions.map((item) => {
                    search.push({param: 'p_jurisdictions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_jurisdictions', value: '' + data.p_jurisdictions});
            }
        }
        if (typeof data.p_education_orientations !== 'undefined' && data.p_education_orientations !== null ) {
            if (Array.isArray(data.p_education_orientations)) {
                data.p_education_orientations.map((item) => {
                    search.push({param: 'p_education_orientations[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_education_orientations', value: '' + data.p_education_orientations});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает ссылку для скачивания файла экспорта списка образовательных организаций
     * @method
     * @name institutionExport
     * @param data - объект с данными типа IInstitutionExport
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionExport(
        data: IInstitutionExport,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/export/{format}'
        .replace(/{format}/ig, (typeof data.format !== 'string')
         ? JSON.stringify(data.format)
         : data.format);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_regions !== 'undefined' && data.p_regions !== null ) {
            if (Array.isArray(data.p_regions)) {
                data.p_regions.map((item) => {
                    search.push({param: 'p_regions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_regions', value: '' + data.p_regions});
            }
        }
        if (typeof data.p_districts !== 'undefined' && data.p_districts !== null ) {
            if (Array.isArray(data.p_districts)) {
                data.p_districts.map((item) => {
                    search.push({param: 'p_districts[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_districts', value: '' + data.p_districts});
            }
        }
        if (typeof data.p_institution_types !== 'undefined' && data.p_institution_types !== null ) {
            if (Array.isArray(data.p_institution_types)) {
                data.p_institution_types.map((item) => {
                    search.push({param: 'p_institution_types[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_types', value: '' + data.p_institution_types});
            }
        }
        if (typeof data.p_institution_kinds !== 'undefined' && data.p_institution_kinds !== null ) {
            if (Array.isArray(data.p_institution_kinds)) {
                data.p_institution_kinds.map((item) => {
                    search.push({param: 'p_institution_kinds[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_kinds', value: '' + data.p_institution_kinds});
            }
        }
        if (typeof data.p_education_levels !== 'undefined' && data.p_education_levels !== null ) {
            if (Array.isArray(data.p_education_levels)) {
                data.p_education_levels.map((item) => {
                    search.push({param: 'p_education_levels[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_education_levels', value: '' + data.p_education_levels});
            }
        }
        if (typeof data.p_okopfs !== 'undefined' && data.p_okopfs !== null ) {
            if (Array.isArray(data.p_okopfs)) {
                data.p_okopfs.map((item) => {
                    search.push({param: 'p_okopfs[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okopfs', value: '' + data.p_okopfs});
            }
        }
        if (typeof data.p_okfses !== 'undefined' && data.p_okfses !== null ) {
            if (Array.isArray(data.p_okfses)) {
                data.p_okfses.map((item) => {
                    search.push({param: 'p_okfses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_okfses', value: '' + data.p_okfses});
            }
        }
        if (typeof data.p_institution_statuses !== 'undefined' && data.p_institution_statuses !== null ) {
            if (Array.isArray(data.p_institution_statuses)) {
                data.p_institution_statuses.map((item) => {
                    search.push({param: 'p_institution_statuses[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_institution_statuses', value: '' + data.p_institution_statuses});
            }
        }
        if (typeof data.p_jurisdictions !== 'undefined' && data.p_jurisdictions !== null ) {
            if (Array.isArray(data.p_jurisdictions)) {
                data.p_jurisdictions.map((item) => {
                    search.push({param: 'p_jurisdictions[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_jurisdictions', value: '' + data.p_jurisdictions});
            }
        }
        if (typeof data.p_education_orientations !== 'undefined' && data.p_education_orientations !== null ) {
            if (Array.isArray(data.p_education_orientations)) {
                data.p_education_orientations.map((item) => {
                    search.push({param: 'p_education_orientations[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_education_orientations', value: '' + data.p_education_orientations});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает юр. лицо по id образовательной организации
     * @method
     * @name institutionGetOrganization
     * @param data - объект с данными типа IInstitutionGetOrganization
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionGetOrganization(
        data: IInstitutionGetOrganization,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/get-organization/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает идентификаторы образовательной организации по ИНН юр. лица
     * @method
     * @name institutionDuplicateInn
     * @param data - объект с данными типа IInstitutionDuplicateInn
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionDuplicateInn(
        data: IInstitutionDuplicateInn,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/check-inn/{inn}'
        .replace(/{inn}/ig, (typeof data.inn !== 'string')
         ? JSON.stringify(data.inn)
         : data.inn);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Получает идентификаторы образовательной организации по ОГРН юр. лица
     * @method
     * @name institutionDuplicateOgrn
     * @param data - объект с данными типа IInstitutionDuplicateOgrn
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionDuplicateOgrn(
        data: IInstitutionDuplicateOgrn,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/check-ogrn/{ogrn}'
        .replace(/{ogrn}/ig, (typeof data.ogrn !== 'string')
         ? JSON.stringify(data.ogrn)
         : data.ogrn);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Сохраняет образовательную организацию и связанное юридическое лицо
     * @method
     * @name institutionSave
     * @param data - объект с данными типа IInstitutionSave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public institutionSave(
        data: IInstitutionSave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/institution/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Сохраняет образовательную услугу для УФТТ 3.0
     * @method
     * @name educationServiceSave
     * @param data - объект с данными типа IEducationServiceSave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationServiceSave(
        data: IEducationServiceSave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-service/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Сохраняет здание
     * @method
     * @name buildingSave
     * @param data - объект с данными типа IBuildingSave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public buildingSave(
        data: IBuildingSave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/building/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Сохраняет подразделение
     * @method
     * @name departmentSave
     * @param data - объект с данными типа IDepartmentSave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public departmentSave(
        data: IDepartmentSave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/department/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Сохраняет инновацию
     * @method
     * @name innovationSave
     * @param data - объект с данными типа IInnovationSave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public innovationSave(
        data: IInnovationSave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/innovation/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Сохраняет договор на осуществление образовательной деятельности
     * @method
     * @name educationContractSave
     * @param data - объект с данными типа IEducationContractSave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public educationContractSave(
        data: IEducationContractSave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/education-contract/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Сохраняет услуги в электронном виде
     * @method
     * @name publicDigitalServiceSave
     * @param data - объект с данными типа IPublicDigitalServiceSave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public publicDigitalServiceSave(
        data: IPublicDigitalServiceSave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/public-digital-service/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Сохраняет территорию
     * @method
     * @name territorySave
     * @param data - объект с данными типа ITerritorySave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public territorySave(
        data: ITerritorySave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/api/institution/territory/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }

}
